import { call, put, takeEvery } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import AddLoanLiabilities from "Communication/ApiClasses/AddLoanLiabilitiesRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleAddLoanLiabilities(action) {
  yield put(doLoadingStart(STRINGS.LIABILITIES.API_KEYS.LOAN_ADD_LIABILITIES));
  const addLoanLiabilities = new AddLoanLiabilities(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.payLoad
  );
  try {
    const result = yield call(addLoanLiabilities.getData);
    yield put({
      type: actionTypes.LOAN_ADD_LIABILITIES_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_ADD_LIABILITIES_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.LIABILITIES.API_KEYS.LOAN_ADD_LIABILITIES)
    );
  }
}

// watcher
function* addLoanLiabilitiesWatcherSaga() {
  yield takeEvery(actionTypes.LOAN_ADD_LIABILITIES, handleAddLoanLiabilities);
}

export default addLoanLiabilitiesWatcherSaga;
